export default "__VITE_PUBLIC_ASSET__7574f1fd__"